import isEmpty from 'lodash/isEmpty';
import { createSelector } from 'reselect';

import { AppState } from 'src/config/appState';

import { getCPProgramState } from '../../selectors/cpProgramSelectors';
import { MindfulnessImprovementsTopicItem } from '../models/weekOne';
import { mindfulnessImprovementsTopics } from '../models/weekOneData';

export const getHowDoYouWantUseMindfulnessData = (state: AppState) =>
    getCPProgramState(state).mindfulnessImprovementsTopics;

export const isHowDoYouWantUseMindfulnessDataValid = createSelector(
    getHowDoYouWantUseMindfulnessData,
    ({ lifeImprovementsTopics, workImprovementsTopics }): boolean =>
        !isEmpty(lifeImprovementsTopics) && !isEmpty(workImprovementsTopics),
);

const getTopicsDescriptions = (field: string) => (acc: string[], targetTopicDefinition: string) => {
    const description = mindfulnessImprovementsTopics[field].find(
        (topic: MindfulnessImprovementsTopicItem) => topic.definition === targetTopicDefinition,
    )!.description;

    return description ? [...acc, description] : acc;
};

export const getMindfulnessImprovementsDescriptions = createSelector(
    getHowDoYouWantUseMindfulnessData,
    mindfulnessImprovementsData => {
        if (!mindfulnessImprovementsData) {
            return [];
        }

        const { workImprovementsTopics, lifeImprovementsTopics } = mindfulnessImprovementsData;

        const workImprovementsTopicsDescriptions = workImprovementsTopics.reduce(
            getTopicsDescriptions('improveWorkTopics'),
            [],
        );

        const lifeImprovementsTopicsDescriptions = lifeImprovementsTopics.reduce(
            getTopicsDescriptions('improvePersonalLifeTopics'),
            [],
        );

        return [...workImprovementsTopicsDescriptions, ...lifeImprovementsTopicsDescriptions];
    },
);

export const isMindfulnessExerciseCompleted = (state: AppState) =>
    getCPProgramState(state).isMindfulnessExerciseCompleted;
